import { InjectionToken } from '@angular/core';

/**
 * Root of the Sparte API, resolved from the active brand and the app's environment by
 * `infrastructureProviders`. Libraries inject this; apps point their generated `BASE_PATH` at it
 * with `useExisting`, because `libs/*` must never name an app's generated interfaces —
 * `@nx/enforce-module-boundaries` rejects that reach.
 */
export const SPARTE_API_BASE_PATH = new InjectionToken<string>('sparteApiBasePath');
